//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    requestBody: {
        name?: null | undefined | string;
        ngram?: null | undefined | string;
        prefix?: null | undefined | string;
        sport?: null | undefined | string;
    };
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/participants -> post -> ${code}`);
    };
};

export const Response200IO = t.array(
    t.interface({
        createdAt: t.union([t.null, t.undefined, t.string]),
        id: t.string,
        name: t.string,
        platformObject: t.union([
            t.null,
            t.undefined,
            t.interface({
                externalId: t.interface({
                    feedId: t.string,
                    instance: t.string,
                    provider: t.string,
                }),
                id: t.string,
                name: t.string,
            }),
        ]),
        sport: t.union([
            t.null,
            t.undefined,
            t.interface({
                displayOrder: t.number,
                id: t.string,
                name: t.string,
                url: t.string,
            }),
        ]),
        sportName: t.union([t.null, t.undefined, t.string]),
        universe: t.union([t.null, t.undefined, t.string]),
        updatedAt: t.union([t.null, t.undefined, t.string]),
    })
);
export type Response200Type = Array<{
    createdAt?: null | undefined | string;
    id: string;
    name: string;
    platformObject?:
        | null
        | undefined
        | {
              externalId: {
                  feedId: string;
                  instance: string;
                  provider: string;
              };
              id: string;
              name: string;
          };
    sport?:
        | null
        | undefined
        | {
              displayOrder: number;
              id: string;
              name: string;
              url: string;
          };
    sportName?: null | undefined | string;
    universe?: null | undefined | string;
    updatedAt?: null | undefined | string;
}>;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiProxyStaffGetParticipantRequest"
 */
export const openapi_proxy_staff_get_participant = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api-proxy/staff/participants${query}`;

    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiProxyStaffGetParticipantParamsType = ParamsType;

export type OpenapiProxyStaffGetParticipantResponseType =
    | {
          status: 200;
          body: Response200Type;
      }
    | {
          status: 400;
          body: Response400Type;
      }
    | {
          status: 401;
          body: Response401Type;
      }
    | {
          status: 500;
          body: Response500Type;
      };

export type OpenapiProxyStaffGetParticipantResponse200Type = Response200Type;

export const openapiProxyStaffGetParticipantRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiProxyStaffGetParticipantResponseType> => {
    const response = await openapi_proxy_staff_get_participant(
        api_url,
        api_timeout,
        backendToken,
        params,
        extraHeaders
    );
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffGetParticipantRequest - unhandled response ${response.status}`);
};
